import React from 'react';
import { VideoContainer } from './style.css'

const Video = (props) => {
    return ( 
        <VideoContainer bg={props.bg}
        >
                <iframe
                  data-sal="fade"
                  data-sal-delay="2000"
                  data-sal-easing="ease"
                    id="vrudo"
                    className="vrudo"
                    src={props.url}
                    allowscriptaccess="always"
                    webkitallowfullscreen="true"
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen
                />
        </VideoContainer>
     );
}
 
export default Video;